import { Copy, KeyRound } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";

interface GeneratedKeyCardProps {
  generatedKey: string;
}

export function GeneratedKeyCard({ generatedKey }: GeneratedKeyCardProps) {
  const [copied, setCopied] = useState(false);

  const copyKey = async () => {
    if (!generatedKey || typeof navigator === "undefined" || !navigator.clipboard) {
      return;
    }

    try {
      await navigator.clipboard.writeText(generatedKey);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch {
      // Clipboard permissions can be denied depending on browser/security context.
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base">
          <KeyRound className="h-4 w-4" /> Your new API key
        </CardTitle>
        <CardDescription>
          Copy it now — for security it will not be shown again.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-2">
        <Input value={generatedKey} readOnly aria-label="Generated API key" className="font-mono" />
        <Button type="button" variant="outline" onClick={copyKey} className="max-sm:w-full">
          <Copy className="h-4 w-4 mr-1.5" />
          {copied ? "Copied" : "Copy key"}
        </Button>
      </CardContent>
    </Card>
  );
}
